import React from "react";
import { createPortal } from "react-dom";

export default function ConfirmModal({
  show,
  title = "확인",
  message,
  onCancel,
  onConfirm,
  container,
  portalTarget,
  confirmLabel = "삭제",
  confirmClass = "btn-danger",
}) {
  if (!show) return null;
  
  const modal = (
    <div className="modal-backdrop-custom">
      <div className="modal-panel p-3">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button type="button" className="btn-close" onClick={onCancel}></button>
        </div>
        <div className="modal-body">
          <p className="mb-0">{message}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel}>
            취소
          </button>
          <button className={`btn ${confirmClass}`} onClick={onConfirm}>
            <i className="fa-regular fa-trash-can me-1"></i>
            {confirmLabel}
          </button>
        </div>
      </div>
      {/* 필요하면 스타일 */}
      <style>{`
        .modal-backdrop-custom{position:fixed;inset:0;background:rgba(0,0,0,.35);
          display:flex;align-items:center;justify-content:center;z-index:1050;}
        .modal-panel{background:#fff;border-radius:12px;min-width:380px;max-width:90vw;
          box-shadow:0 10px 30px rgba(0,0,0,.2);}
        .modal-header,.modal-footer{padding:.75rem 1rem;border-bottom:1px solid #eee;}
        .modal-footer{border-top:1px solid #eee;border-bottom:0; gap: 5px;}
        .modal-body{padding:1rem;}
      `}</style>
    </div>
  );

  // ✅ container가 document면 document.body, 노드면 그대로 사용. 없으면 현재 document.body
  const target = (container && (container.body || container)) || document.body;
  return createPortal(modal, portalTarget || document.body);
}
